import { request } from '../api';

/** Mirrors `apps/api/src/skill-agents/skill-agents.service.ts` (ADR-0011). */

export type SkillAgentStatus = 'learning' | 'working' | 'paused';
export type RunOutcome = 'done' | 'needs_human' | 'nothing' | 'failed';

export interface AgentTaskBrief {
  id: string;
  key: string;
  title: string;
  status: string;
  updatedAt: string;
}

export interface SkillAgentRun {
  id: string;
  outcome: RunOutcome;
  summary: string;
  playbookStep: number;
  skillVersion: string | null;
  startedAt: string;
  finishedAt: string;
  task: AgentTaskBrief | null;
  dialog: { id: string; title: string } | null;
}

export interface SkillAgent {
  id: string;
  slug: string;
  name: string;
  role: string;
  business: { id: string; name: string };
  actorId: string;
  folder: string;
  pools: string[];
  knowledgeTags: string[];
  playbookStep: number;
  skillVersion: string | null;
  model: string | null;
  schedule: string | null;
  status: SkillAgentStatus;
  note: string | null;
  openTasks: number;
  questions: number;
  lastRun: SkillAgentRun | null;
  updatedAt: string;
}

export interface SkillAgentDetail extends SkillAgent {
  tasks: AgentTaskBrief[];
  openQuestions: AgentTaskBrief[];
  runs: SkillAgentRun[];
}

export const skillAgentsApi = {
  list: (): Promise<SkillAgent[]> => request('/skill-agents'),
  get: (slug: string): Promise<SkillAgentDetail> => request(`/skill-agents/${encodeURIComponent(slug)}`),
};
